import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ContactModal from "../../utils/ContactModal";

const ActionReviwerSection = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <section className="section-action wow fadeInUp">
      <ContactModal isOpen={isOpen} setOpen={setIsOpen} isDemo={true} />
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <article className="action-block">
              <div className="additional-bg">
                <div className="additional-bg_in"></div>
              </div>
              <div className="action-content">
                <h3>{t("configuratorReviewsTitle")}</h3>
                <div className="action-text">
                  <div className="action-text_left">
                    {t("reviewerReviewsDesc")}
                  </div>
                  <div className="action-right">
                    <a
                      href="javascript:void(0);"
                      onClick={() => setIsOpen(true)}
                      className="btn btn-border"
                    >
                      <span>{t("tryDemoBtn")}</span>
                    </a>
                  </div>
                </div>
              </div>
            </article>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ActionReviwerSection;
